import moment from 'moment'
import { BULK_TRANS_TYPE } from '../../../server/constants'
export const schYearRecObj = {
  "loggedUser": "",
  "schoolYear": "",
  "isEmergeLunchReimburse": false,
  "reCertificationDueDate": undefined,
  "emergeLunch": false,
  "name": "",
  "acceptMealDonation": false,
  "donationMealPrice": 0.00,
  "posidVerificationReq": false,
  "disableAlaCarteByNegBalance": false,
  "disableAlaCarteBeforeEntree": false,
  "defaultStudentLookup": "",
  "enablePosSession": false,
  "sessionStartDateTime": moment(),
  "sessionEndDateTime": moment(),
  "schoolActualStartDate": undefined,
  "copySettings": false,
  "attendanceFactor": 0.00,
  "emrgLunchFreePrice": 0.00,
  "emrgLunchRedPrice": 0.00,
  "emrgLunchRegPrice": 0.00,
  "emrgMilkFreePrice": 0.00,
  "emrgMilkRedPrice": 0.00,
  "emrgMilkRegPrice": 0.00,
  "isFreeMeal": false,
  "autoDecisionEligibility": true,
  "stateIncomeEligEnabled": true,
  "labelSize": 1,
  "customMessage": "",
  "isSalesTax": false,
  "salesTaxPerc": 0.00,
  "hideMealElig": false,
  "dailySpendingLimit": false,
  "adverseActionProcedure": false,
  "vendorName": '',
  "cepFreeApprovedMeals": undefined,
  "cepFreeApprovedMealsPercentage": undefined,
  "cepFreeApprovedPercentageChbk": false,
  "cepFreeApprovedChbk": false,
  "bulkTransactionsType": BULK_TRANS_TYPE.MEALCOUNT,
  "enableSISEligibility": false,
  "reimbursementRatesInfos": [
    {
      id: 0,
      "reimbursementType": "Regular",
      "reimbursementMealsType": "Milk",
      "redFedReimbRate": 0.0000,
      "freFedReimbRate": 0.0000,
      "totFedReimbRate": 0.0000,
      "redStateReimbRate": 0.0000,
      "freStateReimbRate": 0.0000,
      "totStateReimbRate": 0.0000
    },
    {
      id: 1,
      "reimbursementType": "Regular",
      "reimbursementMealsType": "Snack",
      "redFedReimbRate": 0.0000,
      "freFedReimbRate": 0.0000,
      "totFedReimbRate": 0.0000,
      "redStateReimbRate": 0.0000,
      "freStateReimbRate": 0.0000,
      "totStateReimbRate": 0.0000
    },
    {
      id: 2,
      "reimbursementType": "Regular",
      "reimbursementMealsType": "Breakfast",
      "redFedReimbRate": 0.0000,
      "freFedReimbRate": 0.0000,
      "totFedReimbRate": 0.0000,
      "redStateReimbRate": 0.0000,
      "freStateReimbRate": 0.0000,
      "totStateReimbRate": 0.0000
    },
    {
      id: 3,
      "reimbursementType": "Regular",
      "reimbursementMealsType": "Lunch",
      "redFedReimbRate": 0.0000,
      "freFedReimbRate": 0.0000,
      "totFedReimbRate": 0.0000,
      "redStateReimbRate": 0.0000,
      "freStateReimbRate": 0.0000,
      "totStateReimbRate": 0.0000
    },
    {
      id: 4,
      "freFedReimbRate": 0.0000,
      "freStateReimbRate": 0.0000,
      "redFedReimbRate": 0.0000,
      "redStateReimbRate": 0.0000,
      "reimbursementMealsType": "Lunch",
      "reimbursementType": "Needy",
      "totFedReimbRate": 0.0000,
      "totStateReimbRate": 0.0000
    },
    {
      id: 5,
      "freFedReimbRate": 0.0000,
      "freStateReimbRate": 0.0000,
      "redFedReimbRate": 0.0000,
      "redStateReimbRate": 0.0000,
      "reimbursementMealsType": "Breakfast",
      "reimbursementType": "Needy",
      "totFedReimbRate": 0.0000,
      "totStateReimbRate": 0.0000
    },
    {
      id: 6,
      "freFedReimbRate": 0.0000,
      "freStateReimbRate": 0.0000,
      "redFedReimbRate": 0.0000,
      "redStateReimbRate": 0.0000,
      "reimbursementMealsType": "Snack",
      "reimbursementType": "Needy",
      "totFedReimbRate": 0.0000,
      "totStateReimbRate": 0.0000
    },
    {
      id: 7,
      "freFedReimbRate": 0.0000,
      "freStateReimbRate": 0.0000,
      "redFedReimbRate": 0.0000,
      "redStateReimbRate": 0.0000,
      "reimbursementMealsType": "Milk",
      "reimbursementType": "Needy",
      "totFedReimbRate": 0.0000,
      "totStateReimbRate": 0.0000
    },
    {
      id: 8,
      "reimbursementType": "CEP",
      "reimbursementMealsType": "Lunch",
      "redFedReimbRate": 0.0000,
      "freFedReimbRate": 0.0000,
      "totFedReimbRate": 0.0000,
      "redStateReimbRate": 0.0000,
      "freStateReimbRate": 0.0000,
      "totStateReimbRate": 0.0000
    },
    {
      id: 9,
      "reimbursementType": "CEP",
      "reimbursementMealsType": "Breakfast",
      "redFedReimbRate": 0.0000,
      "freFedReimbRate": 0.0000,
      "totFedReimbRate": 0.0000,
      "redStateReimbRate": 0.0000,
      "freStateReimbRate": 0.0000,
      "totStateReimbRate": 0.0000
    },
    {
      id: 10,
      "reimbursementType": "CEP",
      "reimbursementMealsType": "Snack",
      "redFedReimbRate": 0.0000,
      "freFedReimbRate": 0.0000,
      "totFedReimbRate": 0.0000,
      "redStateReimbRate": 0.0000,
      "freStateReimbRate": 0.0000,
      "totStateReimbRate": 0.0000
    },
  ],
  benefitsPersonName: '',
  benefitsPersonEmail: '',
  benefitsPersonDesignation: '',
  benefitsPersonPhone: '',
  benefitsPersonPhoneExt: '',
  menuCutOffSettings: {
    dateSelected: true,
    dayOfMonth: 0,
    dayOfWeek: "",
    daySelected: false,
    noOfDaysBeforeSelected: false,
    numberOfDaysBefore: 0,
    preOrderingOfAlacarteItemsAllowed: false,
    salesTaxRate: 0,
    sideSelectionAllowedDuringPreOrder: false,
    timeWithMinutes: "00:00"
  },
  lunchRegularCents: undefined,
  lunchReducedCents: undefined,
  breakfastRegularCents: undefined,
  breakfastReducedCents: undefined,
  snackRegularCents: undefined,
  snackReducedCents: undefined,
  dinnerRegularCents: undefined,
  dinnerReducedCents: undefined,
  tempRecertificationEmailFrequency: undefined,
  enableTempRecertReminder: undefined,
  enableConfirmingOfficial: false,
  confirmingOfficials: []

}


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/ManageSchools/schYearRecObj.js